import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { useTheme } from 'styled-components';
import { BorderLinearProgressProps, IDabaduProgressBars } from './LinearProgressInterface';

const BorderLinearProgress = styled((props: BorderLinearProgressProps) => {
  const { ...rest } = props;
  return <LinearProgress {...rest} />;
})(({ themes }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: themes.colors.primaryDisabled,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: themes.colors.primaryColor,
  },
}));

export const DabaduProgressBars: React.FC<IDabaduProgressBars> = ({ value }) => {
  const theme = useTheme();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <BorderLinearProgress variant='determinate' themes={theme} value={value} />
    </Box>
  );
};
